import type {
  ILocationDocument,
  ILocationUploadDocument,
} from '~/types/document/models'
import { makeDocumentService } from '~/cynqueModules/factoriesForServices/documents'

export const {
  createDocument: createLocationDocument,
  updateDocument: updateLocationDocument,
  deleteDocument: deleteLocationDocument,
} = makeDocumentService<ILocationDocument, ILocationUploadDocument>(
  '/api/locationdocuments',
  'locationDocument'
)
